import { render } from "./CoTeacher.vue?vue&type=template&id=4dd25a00&scoped=true"
import script from "./CoTeacher.vue?vue&type=script&lang=js"
export * from "./CoTeacher.vue?vue&type=script&lang=js"

import "./CoTeacher.vue?vue&type=style&index=0&id=4dd25a00&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dd25a00"]])

export default __exports__